import { useEffect } from 'react';
import TagManager from 'react-gtm-module';
// Our entire GTM set up needs to be analyzed to become dynamic. Since we have removed all of the window variables
// we no longer have access to the UID, email or adcount.
export const useGoogleTagManager = () => {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      const tagManagerArgs = {
        gtmId: 'GTM-PDCHPL',
        dataLayer: {
          uid: 0,
          adtype: window?.NEXT_PUBLIC_VERSION,
          adCount: window?.NEXT_PUBLIC_BOOKING_COUNT,
          emailID: window?.NEXT_PUBLIC_OWNER_EMAIL,
        },
      };

      TagManager.initialize(tagManagerArgs);
    }
  }, []);
};
